/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "avahrjwyynzeocqpyfhw"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF2YWhyand5eW56ZW9jcXB5Zmh3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjgzMTMyMTQsImV4cCI6MjA0Mzg4OTIxNH0.NjfoTSEriytuFvmwuUl6bABU4MseKSRk_oKAD_VFYbQ"